var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCake(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_2946)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#47D5DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5926 6.22498C6.3301 4.85998 7.3801 3.59998 8.7451 3.59998C9.9526 3.59998 10.9501 4.59748 10.9501 5.80498V8.53498C11.2651 8.53498 11.5801 8.48248 11.8951 8.48248C12.2101 8.48248 12.4726 8.48248 12.7876 8.53498V5.80498C12.7876 4.59748 13.7851 3.59998 14.9926 3.59998C16.3576 3.59998 17.4076 4.85998 17.1976 6.22498L16.6201 9.42748C18.6676 10.32 20.2426 11.895 20.2426 13.8375V15.045C20.2426 16.6725 19.1926 18.0375 17.6701 18.93C16.1476 19.875 14.1526 20.4 11.8951 20.4C9.6376 20.4 7.6426 19.875 6.1201 18.93C4.6501 18.0375 3.6001 16.6725 3.6001 15.045V13.8375C3.6001 11.895 5.1226 10.32 7.1701 9.42748L6.5926 6.22498ZM15.8326 9.84748L16.5151 6.06748C16.6726 5.12248 15.9901 4.22998 14.9926 4.22998C14.1526 4.22998 13.4701 4.91248 13.4701 5.75248V9.21748C13.2601 9.16498 12.9976 9.16498 12.7876 9.16498C12.4726 9.16498 12.2101 9.11248 11.8951 9.11248C11.5801 9.11248 11.2651 9.11248 10.9501 9.16498C10.7401 9.16498 10.4776 9.21748 10.2676 9.21748V5.80498C10.2676 4.96498 9.5851 4.28248 8.7451 4.28248C7.8001 4.28248 7.0651 5.17498 7.2751 6.11998L7.9576 9.89998C5.7526 10.74 4.2826 12.21 4.2826 13.89V15.0975C4.2826 17.67 7.6951 19.77 11.8951 19.77C16.0951 19.77 19.5076 17.67 19.5076 15.0975V13.89C19.5601 12.1575 18.0901 10.6875 15.8326 9.84748Z",
    fill: "#633001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.56 15.045C19.56 17.6175 16.1475 19.7175 11.9475 19.7175C7.74746 19.7175 4.33496 17.6175 4.33496 15.045V13.8375H19.6125V15.045H19.56Z",
    fill: "#FEDC90"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.27496 6.11997C7.06496 5.17497 7.79996 4.28247 8.74496 4.28247C9.58496 4.28247 10.2675 4.96497 10.2675 5.80497V9.26997C10.7925 9.21747 11.3175 9.16497 11.895 9.16497C12.42 9.16497 12.945 9.21747 13.47 9.26997V5.80497C13.47 4.96497 14.1525 4.28247 14.9925 4.28247C15.9375 4.28247 16.6725 5.17497 16.515 6.11997L15.8325 9.89997C18.0375 10.74 19.56 12.21 19.56 13.89C19.56 16.4625 16.1475 18.5625 11.9475 18.5625C7.74746 18.5625 4.33496 16.4625 4.33496 13.89C4.33496 12.21 5.80496 10.74 8.00996 9.89997L7.27496 6.11997Z",
    fill: "#D1884F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.79499 13.5225C9.79499 14.205 9.42749 14.7825 8.95499 14.7825C8.48249 14.7825 8.11499 14.205 8.11499 13.5225C8.11499 12.84 8.48249 12.2625 8.95499 12.2625C9.42749 12.2625 9.79499 12.84 9.79499 13.5225Z",
    fill: "#633001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6224 13.5225C15.6224 14.205 15.2549 14.7825 14.7824 14.7825C14.3099 14.7825 13.9424 14.205 13.9424 13.5225C13.9424 12.84 14.3099 12.2625 14.7824 12.2625C15.2549 12.2625 15.6224 12.84 15.6224 13.5225Z",
    fill: "#633001"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_2946"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCake);
export default __webpack_public_path__ + "static/media/cake.781d6436dc44365d808db278eeffb08c.svg";
export { ForwardRef as ReactComponent };